import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  public routeUrl;
  public bannerImages = {
    'about': 'S1',
    'commercial-refrigeration': 'S28',
    'contact': 'S7',
    'customers': 'S31',
    'ice-machines' : 'S20',
    'soft-serve-machines': 'S2'
  };
  public slideShowImages = ['S1', 'S2', 'S20', 'S28', 'S7'];
  public currentImageIndex = 0;

  constructor(private router: Router) { }

  ngAfterViewInit() {
    this.router.events.subscribe((event: any) => {
      this.routeUrl = event.url.replace('/', '');
    });

    setInterval(() => {
      this.currentImageIndex = this.currentImageIndex > this.slideShowImages.length - 2 ?
        0 : this.currentImageIndex + 1;
    }, 4000);
  }

  public get bannerImage() {
    const image = this.bannerImages[this.routeUrl];
    return this.getImageUrl(image);
  }

  public getImageUrl(image: string) {
    return `url('./assets/images/${image}.jpg')`;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts